import { keymap } from 'prosemirror-keymap';

export default keymap;
